module.exports = __webpack_public_path__ + "img/favicon-32x32.02ff369.png";